import { render, staticRenderFns } from "./IntegrationItem.vue?vue&type=template&id=604063de&"
import script from "./IntegrationItem.vue?vue&type=script&lang=js&"
export * from "./IntegrationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604063de')) {
      api.createRecord('604063de', component.options)
    } else {
      api.reload('604063de', component.options)
    }
    module.hot.accept("./IntegrationItem.vue?vue&type=template&id=604063de&", function () {
      api.rerender('604063de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrationapps/IntegrationItem.vue"
export default component.exports